import {Directive} from '@angular/core';
import {Individu, IndividuService} from '@Common/core/services';
import {Observable} from 'rxjs';
import {rolesDar} from './roles-dar';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class RoleHelper {
  public static setRolesConnecte(individuSvc: IndividuService, individu: Individu, rolesConnecte: rolesDar[]) {
    if (individuSvc.hasRole(individu, rolesDar.gestionnaire)) {
      rolesConnecte.push(rolesDar.gestionnaire);
    }
    if (individuSvc.hasRole(individu, rolesDar.masse_salariale)) {
      rolesConnecte.push(rolesDar.masse_salariale);
    }
    if (individuSvc.hasRole(individu, rolesDar.sbtcp)) {
      rolesConnecte.push(rolesDar.sbtcp);
    }
    if (individuSvc.hasRole(individu, rolesDar.drh)) {
      rolesConnecte.push(rolesDar.drh);
    }
    if (individuSvc.hasRole(individu, rolesDar.commission)) {
      rolesConnecte.push(rolesDar.commission);
    }
    if (individuSvc.hasRole(individu, rolesDar.commission_consult)) {
      rolesConnecte.push(rolesDar.commission_consult);
    }
    if (individuSvc.hasRole(individu, rolesDar.spta)) {
      rolesConnecte.push(rolesDar.spta);
    }
    if (individuSvc.hasRole(individu, rolesDar.spte)) {
      rolesConnecte.push(rolesDar.spte);
    }
    if (individuSvc.hasRole(individu, rolesDar.recrutement)) {
      rolesConnecte.push(rolesDar.recrutement);
    }
    if (individuSvc.hasRole(individu, rolesDar.spta_traitement)) {
      rolesConnecte.push(rolesDar.spta_traitement);
    }
    if (individuSvc.hasRole(individu, rolesDar.recrutement_spte)) {
      rolesConnecte.push(rolesDar.recrutement_spte);
    }
    if (individuSvc.hasRole(individu, rolesDar.dvc)) {
      rolesConnecte.push(rolesDar.dvc);
    }
  }
  public static hasRoleConnecteAsync(role: rolesDar, rolesConnecte: rolesDar[]): Observable<boolean> {
    return new Observable(observer => {
      if (rolesConnecte && rolesConnecte.length > 0) {
        const connecteHasRole = RoleHelper.hasRole(role, rolesConnecte);
        observer.next(connecteHasRole);
        observer.complete();
      } else {
        observer.next(false);
        observer.complete();
      }
    });
  }

  public static hasRole(role: rolesDar, rolesConnecte: rolesDar[] = []): boolean {
    const find = rolesConnecte.find((_role) => _role === role);
    return !!find;
  }
}
